import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSubscriptionStatus } from "../../reducers/subscriptionStatus/actions";
import CheckCircle from "../../assets/svg/success.svg";
import Spinner from "../Spinner";
import { purchase } from "../../gtm/ecommerce";
import { handleAnalyticsConsent } from "../../osano";
import { v4 as uuidv4 } from "uuid";
import { productNames } from "../../constants/appData";
import { log } from "../../telemetry/analytics";
import { freeTrialPlan } from "../../utils/constants";
import {
  ECOMMERCE_START_USING_CLICKED,
  ECOMMERCE_THANK_YOU_VIEWED,
  ECOMMERCE_SUBSCRIPTION_ACTIVATION_SUCCESS,
} from "../../telemetry/constants";
import { Checkmark, Container } from "./ThankYou.styled";
import {
  Anchor,
  Button,
  Card,
  Type,
} from "discover.medical.react-component-library";

export const ThankYouContainer = (props) => {
  const { terminal, successful, productCode, currentPlan, isFreeTrial } = props;
  const productName = productNames[productCode];

  const getPlan = () => {
    return isFreeTrial ? freeTrialPlan : currentPlan;
  };

  const isSuccessful = () => {
    return terminal && successful;
  };

  const isUnsuccessful = () => {
    return terminal && !successful;
  };

  useEffect(() => {
    props.getSubscriptionStatus();
    handleAnalyticsConsent(() => {
      log(ECOMMERCE_THANK_YOU_VIEWED, {
        free_trial: isFreeTrial,
      });
    });
  }, []);

  useEffect(() => {
    if (terminal && successful && (isFreeTrial || currentPlan)) {
      if (window.Osano && window.Osano.cm.analytics) {
        const plan = getPlan();
        const uuid = uuidv4();

        purchase(plan.id, plan.price, plan.description, uuid);

        log(ECOMMERCE_SUBSCRIPTION_ACTIVATION_SUCCESS, {
          id: plan.id,
          price: plan.price,
          name: plan.description,
        });
      }
    }
  }, [terminal, successful]);

  const handleStartClick = () => {
    if (window.Osano && window.Osano.cm.analytics) {
      log(ECOMMERCE_START_USING_CLICKED, {});
    }
    successful
      ? window.location.replace("/silentPUAReAuthentication")
      : window.location.replace("/logout");
  };

  const title = isFreeTrial
    ? "Thank you for signing up"
    : "Thank you for your purchase";

  const processingMessage = isFreeTrial
    ? "Please wait while we set up your account. This may take up to 30 seconds."
    : "Please wait while we process your payment and set up your account. This may take up to 30 seconds.";

  return (
    <Container container column>
      {isSuccessful() && <Checkmark src={CheckCircle} alt="checkmark" />}
      {isSuccessful() && (
        <Type
          element="h1"
          styledAs="h2"
          fontFamily="secondary"
          data-auto="thankYouText"
        >
          {title}
        </Type>
      )}
      <Card marginBottom="sm">
        {!terminal && (
          <Type element="p" textAlign="center">
            {processingMessage}
          </Type>
        )}
        {isUnsuccessful() && (
          <Type element="p" textAlign="center">
            We're sorry, but we're having trouble activating your subscription.
            Please contact us at{" "}
            <Anchor href="mailto:medicalsupport@ebsco.com">
              medicalsupport@ebsco.com
            </Anchor>
            .
          </Type>
        )}
        {isSuccessful() && (
          <Type element="p" textAlign="center">
            We have successfully activated your subscription.
          </Type>
        )}
      </Card>
      {!terminal && <Spinner />}
      {successful && (
        <Button data-auto="startButton" onClick={handleStartClick}>
          {`Go to ${productName}`}
        </Button>
      )}
    </Container>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSubscriptionStatus,
    },
    dispatch
  );

export const mapStateToProps = ({
  subscriptionStatus,
  productInfo,
  quote,
}) => ({
  terminal: subscriptionStatus.terminal,
  successful: subscriptionStatus.successful,
  productCode: productInfo.productCode,
  currentPlan: quote.currentPlan,
});

export default connect(mapStateToProps, mapDispatchToProps)(ThankYouContainer);
